import React from "react";
import PropTypes from "prop-types";

import Columns from "../columns/index.js";

import styles from "./styles.module.scss";

function Topper(props) {
  switch (props.layout) {
    // todo: do assetLeft and assetRight
    case "cascade":
    default:
      return (
        <div className={styles.topper} data-topper-type="cascade">
          <Columns numberOfColumns={1}>
            <h1>{props.heading}</h1>
            {props.description && (
              <span className={styles.topperDescription}>
                {props.description}
              </span>
            )}
            {props.asset}
            <span className={styles.topperDateTimeTags}>
              {props.tags && props.tags}
              {props.dateTime && (
                <span className={styles.topperDateTime}>{props.dateTime}</span>
              )}
            </span>
          </Columns>
        </div>
      );
  }
}

Topper.defaultProps = {
  asset: null,
  dateTime: null,
  description: null,
  heading: null,
  layout: "cascade",
  tags: null
};

Topper.propTypes = {
  asset: PropTypes.node,
  dateTime: PropTypes.string,
  description: PropTypes.string,
  heading: PropTypes.string.isRequired,
  layout: PropTypes.oneOf(["cascade", "assetLeft", "assetRight"]),
  tags: PropTypes.node
};

export default Topper;
